import script from "./ChatHistoryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatHistoryView.vue?vue&type=script&setup=true&lang=ts"

import "./ChatHistoryView.vue?vue&type=style&index=0&id=70332ef9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70332ef9"]])

export default __exports__